// @see {@link ../configuration/README.md}
export const DefaultXmlConfiguration = {
    generateElementAnnotations: true,
    generateTypeAnnotations: true,
    generateSawsdl: true,
    extractAllTypes: false,
    /**
     * If set, the common xml schema will be referenced instead of bundled.
     */
    commonXmlSchemaExternalLocation: null,
};
export class XmlConfigurator {
    static KEY = "xml";
    static getFromObject(configurationObject) {
        return configurationObject?.[XmlConfigurator.KEY] ?? {};
    }
    static setToObject(configurationObject, options) {
        return { ...configurationObject, [XmlConfigurator.KEY]: options };
    }
    static merge(...options) {
        let result = {};
        for (const option of options) {
            if (option.generateElementAnnotations !== undefined) {
                result.generateElementAnnotations = option.generateElementAnnotations;
            }
            if (option.generateTypeAnnotations !== undefined) {
                result.generateTypeAnnotations = option.generateTypeAnnotations;
            }
            if (option.generateSawsdl !== undefined) {
                result.generateSawsdl = option.generateSawsdl;
            }
            if (option.extractAllTypes !== undefined) {
                result.extractAllTypes = option.extractAllTypes;
            }
            if (option.commonXmlSchemaExternalLocation !== undefined) {
                result.commonXmlSchemaExternalLocation = option.commonXmlSchemaExternalLocation;
            }
        }
        return result;
    }
    static getDefault() {
        return DefaultXmlConfiguration;
    }
}
//# sourceMappingURL=configuration.js.map